import { DungChungService } from '../../../../nfc/dung-chung/__services/dung-chung.service';
import { CommonConFig } from '../../../../nfc/dung-chung/__model/common_config.model';

import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { SubheaderService } from '../../../../../../core/_base/layout/services/subheader.service';
import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ViewChildren, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { tap, debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { merge, BehaviorSubject, fromEvent } from 'rxjs';
//Datasource
//Service
import { LayoutUtilsService, QueryParamsModel } from '../../../../../../core/_base/crud';
import { environment } from '../../../../../../../environments/environment';
import { DynamicSearchFormService } from '../../../../components/dynamic-search-form/dynamic-search-form.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { eventTarget } from '@amcharts/amcharts4/.internal/core/utils/DOM';
import { YeuCauDuyetGiaService } from '../yeu-cau-duyet-gia-service/yeu-cau-duyet-gia.service';
//Model


@Component({
	selector: 'm-khach-hang-feedback',
	templateUrl: './khach-hang-feedback.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class KhachHangFeedbackComponent implements OnInit {
	// Config Form 
	CONFIG: CommonConFig;

	isChange: boolean = false;		// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	saveAddedTTHV: number[] = [];
	viewLoading = false;

	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	saveNewTTHV: number[] = []
	flagHighlight: boolean = false;
	previousIndex: number;
	fixedPoint = 2;
	listdachon: any[] = [];
	//#endregion Khai báo biến
	//#region Constructor
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dungChung: DungChungService,
		public dialog: MatDialog,
		private router: Router,
		private duyetGiasvc: YeuCauDuyetGiaService,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private tokenStorage: TokenStorage,
		public dialogRef: MatDialogRef<KhachHangFeedbackComponent>,
		private dynamicSearchFormService: DynamicSearchFormService,
		private layoutUtilsService: LayoutUtilsService) {
		this.dialogRef.disableClose = true;
	}
	//#endregion Constructor

	//#region Load Data
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.CONFIG.PAGE_SIZE_LIST = environment.pageSize;
		
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			
		});

	}
	ngAfterViewInit() {
	}
	//#endregion Load Data
	back() {
		
		this.dialogRef.close({});
	}
	Save(){
		const dialogRef = this.layoutUtilsService.POP02('');
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;	
			}
			this.duyetGiasvc.saveKHFeedback(this.data).subscribe(res => {
				if (res.status == 1) {
					const message = 'Lưu feedback khách hàng thành công.';
					this.layoutUtilsService.showInfo(message);
					this.changeDetect.detectChanges();
					this.dialogRef.close({
						
					});
				}
				else {
					const message = res.error.message;
					this.layoutUtilsService.showInfo(message);
					this.changeDetect.detectChanges();
				}
			});
			
		})
	}
	isConfirm(confirm:boolean){
		const dialogRef = this.layoutUtilsService.POP02('');
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			if (confirm) {
				this.data.TrangThai_Code = 'KDYCDG_HOANTAT'
				this.data.TrangThai_Desc = 'Hoàn tất'
			}
			else {
				this.data.TrangThai_Code = 'KDYCDG_KHONGDUYET'
				this.data.TrangThai_Desc = 'Không duyệt'
			}
			this.duyetGiasvc.confirmDetail(this.data).subscribe(res => {
				if (res.status == 1) {
					const message = 'Thao tác thành công.';
					this.layoutUtilsService.showInfo(message);
					this.changeDetect.detectChanges();
					this.dialogRef.close({
						
					});
				}
				else {
					const message = res.error.message;
					this.layoutUtilsService.showInfo(message);
					this.changeDetect.detectChanges();
				}
			});
		});
		
	}
	
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}
	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}

}
